import React, { Component } from 'react';

class IconSwarm extends Component {
  render() {
    return (

      <div class="icon icon-swarm">

      <svg viewBox="0 0 52 52" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd"
      clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="1.414">
          <g id="icon-swarm">
              <ellipse id="Oval" cx="25.621" cy="25.586" rx="25.621" ry="25.586" fill="#f3923c"
              />
              <g id="Shape" fill="#f1f2f2">
                  <path d="M21.859 36.56a16.573 16.573 0 0 1-1.411-6.266c-1.41 2.186-2.481 4.42-3.21 6.023-.048.097-.048.146-.097.243-.243.632-.487 1.118-.633 1.555a.97.97 0 0 0 .584 1.263c.389.146.924.34 1.556.583.098.048.147.048.244.096 1.703.583 4.037 1.215 6.567 1.652a16.67 16.67 0 0 1-3.6-5.149M25.017 20.389c-4.962-10.153-16.052-9.813-17.803-5.246-1.362 3.497 4.524 11.804 18.047 5.78-.049-.048-.195-.437-.244-.534M27.317 19.502c-2.772-6.85 2.092-10.784 4.718-9.764 1.995.777 3.065 6.655-4.572 10.055a.83.83 0 0 0-.146-.291M41.331 27.622c-1.168-2.575-3.259-4.469-5.74-5.343a2.02 2.02 0 0 0-.778-.146c-1.265 0-2.53 1.069-2.627 2.38-.194 2.235.243 4.47 1.216 6.655.973 2.138 2.335 3.935 4.037 5.295.438.34 1.022.486 1.557.486 1.022 0 1.994-.534 2.384-1.457 1.07-2.381 1.119-5.247-.049-7.87"
                  />
                  <path d="M35.417 38.988c-2.14-1.651-3.843-3.837-5.01-6.509-1.216-2.72-1.703-5.489-1.459-8.209a5.209 5.209 0 0 1 .632-2.137c-.048 0-.145.048-.195.048-.097.049-.243.049-.34.097-.73.195-1.459.535-2.092.875-.34.194-.632.388-.972.583-1.654 1.117-3.016 3.06-3.211 5.1-.194 2.186.195 4.421 1.119 6.558a13.336 13.336 0 0 0 3.94 5.1c1.022.826 2.822 1.312 4.33 1.312 1.653 0 3.404-.631 4.815-1.506 0 0 .049 0 .049-.048.097-.049.194-.146.292-.194.048-.05.097-.098.146-.098a5.686 5.686 0 0 1-2.044-.972"
                  />
              </g>
          </g>
      </svg>

      </div>

    );
  }
}

export default IconSwarm;



// WEBPACK FOOTER //
// ./src/assets/components/icons/iconSwarm.js